import PropTypes from 'prop-types';

const displayName = 'ModalInfo';

const propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  desc: PropTypes.string,
  btn: PropTypes.string,
  icon: PropTypes.any,
};

const defaultProps = {
  visible: false,
};

export default { displayName, propTypes, defaultProps };
